import * as React from "react"
import { cn } from "../../lib/utils"

const CardWidget = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "dsw-rounded-lg dsw-border dsw-bg-card dsw-text-card-foreground dsw-shadow-sm",
      className
    )}
    {...props}
  />
))
CardWidget.displayName = "CardWidget"

const CardWidgetHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("dsw-flex dsw-flex-col dsw-space-y-1.5 dsw-p-6", className)}
    {...props}
  />
))
CardWidgetHeader.displayName = "CardWidgetHeader"

const CardWidgetTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      "dsw-text-2xl dsw-font-semibold dsw-leading-none dsw-tracking-tight",
      className
    )}
    {...props}
  />
))
CardWidgetTitle.displayName = "CardWidgetTitle"

const CardWidgetDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("dsw-text-sm dsw-text-muted-foreground", className)}
    {...props}
  />
))
CardWidgetDescription.displayName = "CardWidgetDescription"

const CardWidgetContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("dsw-p-6 dsw-pt-0", className)} {...props} />
))
CardWidgetContent.displayName = "CardWidgetContent"

const CardWidgetFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("dsw-flex dsw-items-center dsw-p-6 dsw-pt-0", className)}
    {...props}
  />
))
CardWidgetFooter.displayName = "CardWidgetFooter"

export { CardWidget, CardWidgetHeader, CardWidgetFooter, CardWidgetTitle, CardWidgetDescription, CardWidgetContent } 